import React, { useEffect, useState } from 'react';
import qr from '../assets/images/qrmenu/qrmenu.png';
import qr1 from '../assets/images/qrmenu/qrmenu1.png';
import qr2 from '../assets/images/qrmenu/qrmenu3.png';
import { useTranslation } from 'react-i18next';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Qrjun = () => {
  const { t, i18n } = useTranslation();
  const images = [
    { src: qr2 },
    { src: qr },
    { src: qr1 },
  ];

  const [hoveredIndex, setHoveredIndex] = useState(null); 

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className=" pb-24 mb-20 bg-[#1f1f2c] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center" data-aos="fade">
          <h2 className="text-white font-aventa text-center mx-auto my-4 md:my-6 lg:my-8 px-4 animate__animated animate__fadeIn animate__delay-2s word-break break-words text-2xl sm:text-3xl tracking-tight">
            QR<span className="text-[#dcbc5c]">jun</span>
          </h2>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-8 lg:gap-10 h-auto px-4 py-8 perspective-1000">
          {images.map((image, index) => {
            let baseTransformClasses = '';
            let initialZIndex = 'z-10';
            let aosAnimation = '';

            if (index === 0) {
              baseTransformClasses = 'md:-translate-x-8 md:-rotate-y-5';
              aosAnimation = 'fade-right';
            } else if (index === 1) {
              baseTransformClasses = 'md:translate-z-60 md:scale-110';
              initialZIndex = 'z-20';
              aosAnimation = 'zoom-in';
            } else if (index === 2) {
              baseTransformClasses = 'md:translate-x-8 md:rotate-y-5';
              aosAnimation = 'fade-left';
            }

            return (
              <div
                key={index}
                className={`relative flex-shrink-0 rounded-xl shadow-2xl overflow-hidden
                           transform-gpu transition-all duration-300 ease-in-out cursor-pointer
                           w-[20rem] h-[28rem] sm:w-80 sm:h-[26rem] md:w-80 md:h-[26rem] lg:w-96 lg:h-[30rem] 
                           ${baseTransformClasses} ${initialZIndex} transform-style-preserve-3d
                           `}
                style={{
                  WebkitBoxReflect: 'below 15px linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.15) 100%)',
                }}
                data-aos={aosAnimation}
                data-aos-delay={index * 150}
              >
                <img
                  src={image.src}
                  alt=""
                  className="w-full h-full object-contain bg-[#1f1f2c] rounded-xl"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-70 rounded-xl"></div>
              </div>
            );
          })}
        </div>

        <div className="mt-20 text-center" data-aos="fade" data-aos-delay="300">
          <p className="text-xl max-w-4xl mx-auto leading-relaxed bg-gradient-to-b from-[#929292] via-[#FFFFFF] to-[#857f7f] bg-clip-text text-transparent">
            {t('qr')}
          </p>
        </div>

        <div className="text-center mt-12" data-aos="fade" data-aos-delay="400"> 
          <a
            href="https://www.qrjun.online"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-gold to-[#1f1f2c] hover:from-gold hover:to-[#1f1f2c]
             text-white font-bold py-3 px-6 sm:py-4 sm:px-8 rounded-full text-base sm:text-lg md:text-xl shadow-lg
             transition-all duration-300 ease-in-out transform hover:scale-105
             focus:outline-none focus:ring-4 focus:ring-[#1f1f2c] focus:ring-opacity-50"
          >
            {t('qrbutton')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Qrjun;